import React from 'react';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import SubSection from './SubSection';
import { OrderingSelectors } from 'polygon-ordering';
import { setCurrentModal } from '../thunks/setCurrentModal';
import { LOCATION_MODAL_ID } from '../modals/LocationModal';
/* import getThemeLookup from '../selectors/getThemeLookup'; */
import SectionContainer from './SectionContainer';
import SubSectionChevron from './SubSectionChevron';

const { getLocation, getSaleType } = OrderingSelectors;

const LocationSummary = () => {
  const dispatch = useAppDispatch();
  const saleType = useAppSelector(getSaleType);
  const unenhancedLocation = useAppSelector(getLocation);
  /* const p = useAppSelector(getThemeLookup); */

  return (
    <SectionContainer>
      <SubSection
        title={unenhancedLocation?.name ?? ''}
        action={() => {
          dispatch(
            setCurrentModal({
              modalId: LOCATION_MODAL_ID,
              params: { saleType, allowRedirect: false, isReviewOrderScreen: true },
            }),
          );
        }}
        rightSlot={() => <SubSectionChevron />}
      />
    </SectionContainer>
  );
};

export default LocationSummary;
